import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import ICloudflareTrace from '~/types/common/client-access'
import IDeviceInfo from '~/types/common/device-info'

interface IClientAccessInfoStore {
  clientAccess: ICloudflareTrace | null
  deviceInfo: IDeviceInfo | null
  setClientAccessInfo: (user: ICloudflareTrace | null) => void
  setDeviceInfo: (data: IDeviceInfo) => void
  resetState: () => void
}

const CLIENT_ACCESS_STORE_KEY = 'client-access-store'

export const useClientAccessStore = create<IClientAccessInfoStore>()(
  persist(
    (set) => ({
      deviceInfo: null,
      clientAccess: null,
      setClientAccessInfo: (clientAccess: ICloudflareTrace | null) =>
        set((state) => {
          return { ...state, clientAccess }
        }),
      setDeviceInfo: (deviceInfo: IDeviceInfo) =>
        set(() => ({
          deviceInfo,
        })),
      resetState: () =>
        set(() => ({
          clientAccess: null,
          deviceInfo: null,
        })),
    }),
    {
      name: CLIENT_ACCESS_STORE_KEY,
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
